import $ from 'jquery';

export default function preloader(params) {

	let $loader = $(params.element);

	if ($loader.css('display') === 'block') {

		$(window).on('load', function () {
			$loader.fadeOut();
			params.callback();
		});

	} else {
		params.callback();
	}

}


// WEBPACK FOOTER //
// ./modules/loader-page.js